import { StoreState } from "..";

export const getPopularFlights = (state: StoreState) => state.popularFlights;
